import { useEffect, useMemo } from 'react';
import { usePageTracking } from 'react-event-tracker';
import { useStoreValue } from 'store';
import { getDataLayerElements } from 'utils/getDataLayerElements';

import { config, PRODUCT_CODE_DAVID_JONES_PREMIERE, PRODUCT_CODE_DAVID_JONES_PRESTIGE } from '_config';
import { getProductInfo } from 'utils';

export const usePageTracker = (siteSubSection, pageTitle, isError) => {
  const [state] = useStoreValue();

  const pageTrackingData = useMemo(() => {
    const compareProductsData =
      pageTitle === 'davidjones-product-comparison'
        ? {
            product: {
              productId: [PRODUCT_CODE_DAVID_JONES_PREMIERE, PRODUCT_CODE_DAVID_JONES_PRESTIGE],
            },
          }
        : '';

    return {
      page: {
        pageType: getPageType(pageTitle, isError),
        siteSection: config.productCode ? getProductInfo().datalayer.siteSection : 'dj',
        siteSubSection,
        pageTitle,
      },
      product: {
        productId: config.productCode ? [config.productCode] : null,
      },
      ...getDataLayerElements(state),
      ...compareProductsData,
    };
  }, [isError, pageTitle, siteSubSection, state]);

  const { trackPageView } = usePageTracking(pageTrackingData, {
    trackPageViewByDefault: false,
  });

  useEffect(() => {
    trackPageView();
  }, [trackPageView, pageTitle]);

  return null;
};

const getPageType = (pageTitle, isError) => {
  const balanceTransferPages = ['balance-transfer', 'credit-limit-request', 'credit-limit-allocation'];
  if (isError) {
    return 'error-page';
  }
  if (balanceTransferPages.includes(pageTitle)) {
    return 'funnel-page-b';
  }

  return 'funnel-page';
};
